import DOMPurify from "dompurify";

const HtmlRenderer = ({htmlString}: any) => {
  // Define your allowlist of permitted href values
  const allowedHrefs = ["/ofac-search/"];

  // Add a hook to check the href attribute during sanitization
  DOMPurify.addHook("uponSanitizeAttribute", function (node, data, config) {
    // Check if the attribute is 'href' and the node is an anchor tag
    if (data.attrName === "href" && node.nodeName === "A") {
      // Check if the href value starts with any of the allowed strings
      if (!allowedHrefs.some(allowedString => data.attrValue.startsWith(allowedString))) {
        // If not in the allowed list, remove the attribute
        data.keepAttr = false;
      }
    }
  });

  const cleanHtml = DOMPurify.sanitize(htmlString, {
    ALLOWED_ATTR: ["href"],
    ALLOWED_TAGS: ["a"],
  });
  const createMarkup = (html: string) => {
    return {__html: html};
  };

  return <div dangerouslySetInnerHTML={createMarkup(cleanHtml)} />;
};

export default HtmlRenderer;
